import { DoubleLeftOutlined } from "@ant-design/icons";
import { Card, Tooltip, Button } from "antd";
import React from "react";

import "./patientProfile.scss";
import { formatCreateDate, formatPhoneNumber } from "@utils/helpers";
import MemberItems from "@pages/member-details/items";

const PatientProfile  = ({setCollapsedProfile,collapsedProfile,patientDetailsList}:any) => {


    return (
        <div className="patientProfile">
            <Card className="patientProfile__card">
                {/* <Row className="patientProfile__card__img-container">
                    <Col span={24} className="patientProfile__card__img-container__profile-img-container">
                       <div className="patientProfile__card__img-container__profile-img-container__profile-image">
                            <Image
                                width={120}
                                height={120}
                                style={{ borderRadius: 60 }}
                                src={""}
                            />
                        </div>
                    </Col>
                </Row> */}

                <div className="patientProfile__card__patient-profile-body">
                    {/* {isloadingpatientInfo ?
                        (   
                            <>
                                <div className="patientProfile__card__patient-profile-body__patientName">{patientName}</div>
                                <div className="patientProfile__card__patient-profile-body__patientId">{patientIdObj.label}: {patientIdObj.value}</div>
                            </>
                        )
                        :"Loading...."
                    } */}

                    <Tooltip
                        overlayInnerStyle={{
                        padding: "12px",
                        borderRadius: "8px",
                        backgroundColor: "#091e42",
                        height: "40px",
                        lineHeight: 1,
                        }}
                        title="Hide Patient Profile"
                    >
                        <Button
                            className="patientProfile__card__patient-profile-body__profile-collapse-btn"
                            icon={<DoubleLeftOutlined />}
                            size={"middle"}
                            onClick={() => setCollapsedProfile(!collapsedProfile)}
                        />
                    </Tooltip>
                    {
                        patientDetailsList.map((patientField: any,index: any)=>{
                            let value = patientField.label === "DOB" ? formatCreateDate(patientField.value) : (patientField.label === "Mobile" ? formatPhoneNumber(patientField.value , "usFormat") : patientField.value)
                            return(
                                index<2 ? (<>{
                                    index === 0 ? <div className="patientProfile__card__patient-profile-body__patientName">{patientField.value}</div>
                                     : <div className="patientProfile__card__patient-profile-body__patientId">{patientField.label}: {patientField.value}</div>}</>
                                ) : 
                                <MemberItems
                                    key={index}
                                    left={9}
                                    right={15}
                                    containerClass={"personalDetailContainer"}
                                    leftClass="f16 w400 clr-lightGrayColor"
                                    rightClass="f16 w500 clr-n125"
                                    name={patientField.label}
                                    value={value}
                                />
                            )
                        })
                    }
                </div>
            </Card>
        </div>
    )
}

export default PatientProfile;